import 'next/stylesheets/components/header-nav-item';

import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-header-nav-item', {
  mixins: [eventListenerMixin],

  properties: {
    newFeature: {
      type: Boolean,
      default: false,
    },

    newFeatureKey: {
      type: String,
    },
  },

  connected() {
    this.link = this.querySelector('a');
    this.listenTo(this.link, 'click', () => {
      if (!this.newFeature) return;
      this.newFeature = false;
      this.update();

      const banner = document.querySelector('tr-feature-banner');
      if (banner) banner.remove();
    });
  },

  update() {
    window.$.post('/new_feature_confirmations', {
      metadata_key: `${this.newFeatureKey}_shown`,
    });
  },

  disconnected() {
    this.stopListening();
  },
});
